import Dropdown from '@/components/DropDown/DropDown';
import SvgIcon from '@/components/SvgIcon';
import { CenterReviewDashboardHeader } from '@/features/centerReview';
import { colors } from '@/lib/colors';
import { DemiLightText } from '@/lib/Text';
import dayjs from 'dayjs';
import React from 'react';
import { TooltipIcon } from '../Settlement/SettlementCalendar';

type Props = {
    centerHeader?: CenterReviewDashboardHeader;
    selectCoach: { code: string; value: string } | null;
    setSelectCoach: (coach: { code: string; value: string }) => void;
};

function FeedInstructorReviewsHeader({ centerHeader, selectCoach, setSelectCoach }: Props) {
    const firstReviewDate = centerHeader?.firstReviewDate
        ? dayjs(centerHeader?.firstReviewDate).format('YYYY.MM.DD')
        : dayjs().format('YYYY.MM.DD');
    const currentDate = centerHeader?.currentDate
        ? dayjs(centerHeader?.currentDate).format('YYYY.MM.DD')
        : dayjs().format('YYYY.MM.DD');
    const coachList =
        centerHeader?.coachList.map((coach) => ({
            code: coach.id,
            value: coach.name,
        })) || [];

    const onClickDropDown = (item: { code: string; value: string }) => {
        setSelectCoach(item);
    };

    return (
        <div className=" flex flex-row items-center mb-[40px]">
            <SvgIcon name="SvgCalendar" size={21} fill={colors.white} stroke={colors.primary} className="mr-[14px]" />
            <DemiLightText
                fontSize={20}
                lineHeight={26}
                color={colors.Text_1}
                className="mr-[8px]"
                letterSpacing={-0.1}
            >
                {firstReviewDate} ~ {currentDate}
            </DemiLightText>
            <TooltipIcon
                title="첫 리뷰가 등록된 시점부터 현재까지의 누적 데이터 기준이에요"
                width={360}
                iconSize={20}
                mr={17}
                fontSize={13}
                fontType="demilight"
            />
            {coachList && coachList.length > 0 && (
                <Dropdown
                    options={coachList}
                    onSelect={onClickDropDown}
                    isAllOption={false}
                    bgColor={'#2D3132'}
                    borderRadius={50}
                    fontSize={17}
                    textColor="white"
                    arrowColor="white"
                    className="py-[12px] "
                    initialSelected={selectCoach?.code}
                />
            )}
        </div>
    );
}

export default FeedInstructorReviewsHeader;
